import { ThemeProvider } from '@emotion/react';
import type {} from '@mui/x-date-pickers/AdapterDayjs';
import { useAppSelector } from 'store/store';
import ScrollToTop from 'components/helpers/ScrollToTop';
// import Spinner from 'components/common/ui/Spinner';
import StyleProvider from 'shared/utils/StyleProvider';
import { evaluateTheme, labTheme, refertingTheme, settingsTheme } from 'shared/styles/themes';
import { useEffect, useState } from 'react';
import './App.css';
import AppRoutes from './AppRoutes';
import { MiniAva } from 'features/mini-ava/MiniAva';
import { useLocation } from 'react-router-dom';
import { userService } from 'features/settings/users/api/user.service';

function App() {
  const BASE_URL = process.env.REACT_APP_MINI_AVA_BASE_URL;
  const [theme, setTheme] = useState(labTheme);
  const isMiniActive = JSON.parse(localStorage.getItem('MINIAVA_ENABLED') || 'false');
  const context = useAppSelector((state) => state.contextData.context);
  const user = useAppSelector((state) => state.auth.user);

  const [apikey, setApikey] = useState<string>(null);

  const clearMiniAvaStorage = () => {
    Object.keys(localStorage)
      .filter((k) => k.includes('user-storage'))
      .forEach((k) => localStorage.removeItem(k));

    Object.keys(sessionStorage)
      .filter((k) => k.includes('user-storage'))
      .forEach((k) => sessionStorage.removeItem(k));
  };

  useEffect(() => {
    const getUser = async () => {
      const res = await userService.me();
      setApikey(res.ava_api_key);
    };
    if (user) {
      getUser();
    } else {
      clearMiniAvaStorage();
      setApikey(null);
    }
  }, [user]);

  useEffect(() => {
    switch (context.toUpperCase()) {
      case 'LAB':
      default:
        setTheme(labTheme);
        break;
      case 'REFERTING':
        setTheme(refertingTheme);
        break;
      case 'SETTINGS':
        setTheme(settingsTheme);
        break;
      case 'EVALUATE':
        setTheme(evaluateTheme);
        break;
    }
  }, [context]);

  const location = useLocation();
  const [avaContextText, setAvaContextText] = useState<string>('');

  useEffect(() => {
    setAvaContextText('');
  }, [location.pathname]);

  useEffect(() => {
    const handleUpdate = (e: Event) => {
      const customEvent = e as CustomEvent<{ text: string; url: string }>;
      const payload = customEvent.detail;

      if (!payload || typeof payload !== 'object') return;

      const { text, url } = payload;

      if (!text || text.trim() === '') {
        setAvaContextText('');
        return;
      }

      if (url !== window.location.pathname) {
        return;
      }
      setAvaContextText(text);
    };

    window.addEventListener('ava-context-update', handleUpdate);

    return () => {
      window.removeEventListener('ava-context-update', handleUpdate);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <StyleProvider />
        {/* <Spinner /> */}
        <ScrollToTop />
        <AppRoutes />
        {user && apikey && isMiniActive && (
          <div key={`${apikey}${user}`}>
            <MiniAva
              apiKey={`Api-Key ${apikey}`}
              baseUrl={`${BASE_URL}`}
              includeContext={true}
              context={avaContextText}
              showAttachments={true}
              showTools={false}
            />
          </div>
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
